import React, { FC } from 'react';
import { TextField } from '@material-ui/core';
import { useTranslate } from 'react-admin';

import { SelectInput } from '~/components';
import { ApprovalCaseActionType } from '~/types/approvalCase';
import { ObjectType } from '~/types/ObjectType';

export const OBJECT_TYPES: ObjectType[] = ['INDIVIDUAL', 'HEAD_TRANSACTION'];

const i18nFilters = 'resources.approvals.list.filters';

interface ActionTypeFilterInputProps {
  value: ApprovalCaseActionType | undefined;
  onChange: (e: any) => void;
  className?: string;
}

export const ActionTypeFilterInput: FC<ActionTypeFilterInputProps> = ({
  value,
  onChange,
  className,
}) => {
  const translate = useTranslate();
  const t = (key: string) => translate(`${i18nFilters}.${key}`);

  const options: { value: ApprovalCaseActionType; text: string }[] = [
    { value: 'CREATE', text: t('actionTypeOptions.CREATE') },
    { value: 'UPDATE', text: t('actionTypeOptions.UPDATE') },
    { value: 'ATOMIC', text: t('actionTypeOptions.ATOMIC') },
    { value: 'TRANSACTION', text: t('actionTypeOptions.TRANSACTION') },
  ];

  return (
    <SelectInput<ApprovalCaseActionType | undefined>
      label={t('actionType')}
      name='actionType'
      value={value}
      options={options}
      onChange={onChange}
      allowEmpty
      className={className}
    />
  );
};

interface ObjectTypeFilterInputProps {
  value: ObjectType | undefined;
  onChange: (e: any) => void;
  className?: string;
}

export const ObjectTypeFilterInput: FC<ObjectTypeFilterInputProps> = ({
  value,
  onChange,
  className,
}) => {
  const translate = useTranslate();
  const tEventType = (type: ObjectType) => translate(`resources.events.show.${type}`);

  const options = OBJECT_TYPES.map((type) => ({ value: type, text: tEventType(type) }));

  return (
    <SelectInput<ObjectType | undefined>
      label={translate(`${i18nFilters}.objectType`)}
      name='objectType'
      value={value}
      options={options}
      onChange={onChange}
      allowEmpty
      className={className}
    />
  );
};

interface ObjectIdFilterInputProps {
  value: string | undefined;
  onChange: (e: any) => void;
  disabled?: boolean;
  className?: string;
}

export const ObjectIdFilterInput: FC<ObjectIdFilterInputProps> = ({
  value,
  onChange,
  disabled,
  className,
}) => {
  const translate = useTranslate();
  const t = (key: string) => translate(`${i18nFilters}.${key}`);

  return (
    <TextField
      label={t('objectId')}
      name='objectId'
      value={value ?? ''}
      onChange={onChange}
      disabled={disabled}
      helperText={disabled ? t('objectIdHint') : undefined}
      className={className}
    />
  );
};

interface RequestedByIdFilterInputProps {
  value: string | undefined;
  onChange: (e: any) => void;
  className?: string;
}

export const RequestedByIdFilterInput: FC<RequestedByIdFilterInputProps> = ({
  value,
  onChange,
  className,
}) => {
  const translate = useTranslate();
  const t = (key: string) => translate(`${i18nFilters}.${key}`);

  return (
    <TextField
      label={t('requestedById')}
      name='requestedById'
      value={value ?? ''}
      onChange={onChange}
      className={className}
    />
  );
};
